import { useCallback, useEffect, useState } from 'react';

/**
 * Scrolls bottom of the element into view on next render after calling the returned callback.
 */
export const useScrollIntoView = (ref: React.RefObject<HTMLDivElement>) => {
  const [isScrollRequired, setIsScrollRequired] = useState(false);

  useEffect(() => {
    if (isScrollRequired) {
      setIsScrollRequired(false);
      ref.current?.scrollIntoView?.({ behavior: 'smooth', block: 'end' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScrollRequired]);

  return useCallback(() => {
    setIsScrollRequired(true);
  }, []);
};
